<template>
  <div>
    <Col span="24">
      <my-header></my-header>
    </Col>
    <Col span="4">
      <left-menu></left-menu>
    </Col>
    <Col span="20">
      <div class="container">
        <slot></slot>
      </div>
    </Col>
  </div>
</template>
<script>
  import MyHeader from "@/components/Header";
  import LeftMenu from "@/components/LeftMenu";

  export default {
    components: {
      MyHeader,
      LeftMenu
    }
  }
</script>
<style>
  .container {
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// Default.vue?7b92d23f